"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./locale/LocaleHandler"));
__export(require("./context/LocalizationContext"));
__export(require("./client/message/ContextMessage"));
__export(require("./locale/MessageLoader"));
__export(require("./locale/utils"));
__export(require("./utils/messageCode"));
__export(require("./hooks/localization.hooks"));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSw0Q0FBdUM7QUFFdkMsbURBQThDO0FBQzlDLHFEQUFnRDtBQUNoRCw0Q0FBdUM7QUFDdkMsb0NBQStCO0FBQy9CLHlDQUFvQztBQUNwQyxnREFBMkMifQ==